import { unref, inject, defineComponent, computed } from 'vue';
import defaultLocaleData from './default';
export default defineComponent({
    compatConfig: { MODE: 3 },
    name: 'LocaleReceiver',
    props: {
        componentName: String,
        defaultLocale: {
            type: [Object, Function],
        },
        children: {
            type: Function,
        },
    },
    setup(props, { slots }) {
        const localeData = inject('localeData', {});
        const locale = computed(() => {
            const { componentName = 'global', defaultLocale } = props;
            const locale = defaultLocale || defaultLocaleData[componentName || 'global'];
            const { antLocale } = localeData;
            const localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
            return {
                ...(typeof locale === 'function' ? locale() : locale),
                ...(localeFromContext || {}),
            };
        });
        const localeCode = computed(() => {
            const { antLocale } = localeData;
            const localeCode = antLocale && antLocale.locale;
            // Had use LocaleProvide but didn't set locale
            if (antLocale && antLocale.exist && !localeCode) {
                return defaultLocaleData.locale;
            }
            return localeCode;
        });
        return () => {
            const children = props.children || slots.default;
            const { antLocale } = localeData;
            return children?.(locale.value, localeCode.value, antLocale);
        };
    },
});
export function useLocaleReceiver(componentName, defaultLocale, propsLocale) {
    const localeData = inject('localeData', {});
    const componentLocale = computed(() => {
        const { antLocale } = localeData;
        const locale = unref(defaultLocale) || defaultLocaleData[componentName || 'global'];
        const localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
        return {
            ...(typeof locale === 'function' ? locale() : locale),
            ...(localeFromContext || {}),
            ...(unref(propsLocale) || {}),
        };
    });
    return [componentLocale];
}
